module.exports = __webpack_public_path__ + "static/media/HCMM384.8158d145.jpg";